module.exports = __webpack_public_path__ + "img/AngelHotpot.195efeb8.svg";